/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { getAllSettings, updateSystemUsageFee } from 'api/globalSettings'
import { useState } from 'react'
import { GlobalSettings } from 'types/GlobalSettings'

export const useGlobalSettingsDialog = () => {
    const [isDialogVisible, setDialogVisible] = useState(false)
    const [settings, setSettings] = useState<GlobalSettings | null>(null)
    const [inputValue, setInputValue] = useState<number | null>(null)
    const [isSaving, setSaving] = useState(false)
    const [error, setError] = useState<Error | null>(null)

    const openDialog = () => {
        setDialogVisible(true)
        loadSettings()
    }

    const closeDialog = () => {
        setDialogVisible(false)
        setError(null)
    }

    const loadSettings = async () => {
        try {
            const fetched = await getAllSettings()
            setSettings(fetched)
            setInputValue(fetched.system_usage_fee_per_ticket)
        } catch (err: any) {
            setError(new Error('A beállítások betöltése sikertelen.'))
        }
    }

    const saveSettings = async () => {
        if (typeof inputValue !== 'number' || isNaN(inputValue)) {
            setError(new Error('Kérlek, adj meg egy érvényes számot.'))
            return
        }

        setSaving(true)
        try {
            await updateSystemUsageFee(inputValue)
            closeDialog()
        } catch (err: any) {
            setError(new Error('A beállítások mentése sikertelen.'))
        } finally {
            setSaving(false)
        }
    }

    return {
        isDialogVisible,
        openDialog,
        closeDialog,
        inputValue,
        setInputValue,
        saveSettings,
        isSaving,
        error,
    }
}
